"use client";

import { Button } from "@oreme/ui";
import Link from "next/link";
import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { ThemeIcon } from "@/components";
import { ThemeTypeEnum } from "@/types";

interface HomeSectionThemeItemProps {
  theme: ThemeTypeEnum;
}

function HomeSectionThemeItem({
  theme,
}: Readonly<HomeSectionThemeItemProps>): ReactElement {
  const t = useTranslations("home.SectionThemeItem");
  return (
    <div className="relative p-4 rounded-lg border overflow-hidden bg-green-400">
      <figure className="absolute -top-2 -right-2 flex justify-end items-end">
        <ThemeIcon color="#000" size={120} theme={theme} />
      </figure>
      <div className="relative z-10">
        <Link
          className="after:absolute after:inset-0"
          href={`/sites/?theme=${theme}`}
        >
          <h3 className="text-lg font-semibold mb-4">{t(theme)}</h3>
          <Button size="sm" variant="outline">
            {t("action")}
          </Button>
        </Link>
      </div>
    </div>
  );
}

export { HomeSectionThemeItem, type HomeSectionThemeItemProps };
